import { render, staticRenderFns } from "./IntegrationDataTable.vue?vue&type=template&id=31cdd7a1&scoped=true"
import script from "./IntegrationDataTable.vue?vue&type=script&lang=js"
export * from "./IntegrationDataTable.vue?vue&type=script&lang=js"
import style0 from "./IntegrationDataTable.vue?vue&type=style&index=0&id=31cdd7a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cdd7a1",
  null
  
)

export default component.exports